module.exports = __webpack_public_path__ + "img/I-BOS-1301-0.d6e0e7b6.png";